import React from 'react';
import PropTypes from 'prop-types';
import { slugify } from 'helpers/slugify';
import { styled } from '@mui/system';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { isMobileMedia } from 'bento-ordering/utils/media';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_SECTION_TITLES
} from 'styles/constants/appearanceSectionNames';

const StyledBox = styled(Box)(({ isFirst }) => ({
  paddingTop: isFirst ? '30px' : '20px',
  paddingBottom: '16px'
}));

const StyledHeader = styled(Typography)(({ theme }) => {
  return {
    outline: 'none',
    color: theme.palette.menuSectionTitles.main
  };
});

const StyledDescription = styled(Typography)(({ theme }) => {
  return {
    fontSize: '16px',
    marginTop: '4px',
    fontStyle: 'normal',
    color: theme.palette.sectionNav.link.main
  };
});

const MenuSectionHeader = ({ title, description, isFirst }) => {
  const tabIndex = !isMobileMedia() ? '-1' : undefined;
  const headerStyles = { variant: MENU_SECTION_TITLES };
  const descriptionStyles = {
    variant: ITEM_DESCRIPTION_AND_PRICES,
    component: 'p'
  };

  return (
    <StyledBox isFirst={isFirst}>
      <StyledHeader
        id={`${slugify(title)}-header`}
        tabIndex={tabIndex}
        {...headerStyles}
      >
        {title}
      </StyledHeader>
      {description && (
        <StyledDescription
          id={`${slugify(title)}-description`}
          tabIndex={tabIndex}
          {...descriptionStyles}
        >
          {description}
        </StyledDescription>
      )}
    </StyledBox>
  );
};

MenuSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  isFirst: PropTypes.bool.isRequired
};

MenuSectionHeader.defaultProps = {
  isFirst: false,
  description: ''
};

export default MenuSectionHeader;
